module.exports = __webpack_public_path__ + "static/media/MHRP77N0007.93b990b7.svg";